import { render, staticRenderFns } from "./billing-details-table.vue?vue&type=template&id=67a4f146&scoped=true&"
import script from "./billing-details-table.vue?vue&type=script&lang=js&"
export * from "./billing-details-table.vue?vue&type=script&lang=js&"
import style0 from "./billing-details-table.vue?vue&type=style&index=0&id=67a4f146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4f146",
  null
  
)

export default component.exports